import "./LauncherPreview.scss"
import React from "react"
import classnames from "classnames"
import { Icon } from "../../../lib"
import { LAUNCHER_TYPES } from "../../../app/constants"

const LauncherPreview = ({ type, prompt, colorStyle }) => {
  const className = classnames("Launcher", `Launcher-${type}`)
  return (
    <div className={className} style={colorStyle}>
      <Icon
        name="chat"
        type="legacy"
        color={colorStyle.color}
        size={type === LAUNCHER_TYPES.ICON ? 28 : 20}
      />
      {type !== LAUNCHER_TYPES.ICON && prompt}
    </div>
  )
}

LauncherPreview.displayName = "LauncherPreview"

export default LauncherPreview



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/LauncherPreview.js